import { zodResolver } from '@hookform/resolvers/zod'
import { Stack } from '@mui/joy'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { uuidOptionsSchema } from '~/shared/lib/schemas'
import { myPalette } from '~/shared/lib/theme'
import { Button } from '~/shared/ui/Buttons'
import { AutocompleteInput, FormProvider } from '~/shared/ui/Form'
import { SlashCircleIcon } from '~/shared/ui/Icons'
import { reasonsTerminationsKeys } from './constant'

const formSchema = z.object({
  reasons: uuidOptionsSchema.min(1, 'Обязательное поле'),
})

export type FormValues = {
  reasons: string[]
}

type FormProps = {
  onSuccess: (formValues: FormValues) => void
  onCancel: () => void
  isSubmitting: boolean
  buttonSuccessTitle?: string
}

export function Form({
  onSuccess,
  onCancel,
  isSubmitting,
  buttonSuccessTitle,
}: FormProps) {
  const { t } = useTranslation()

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
  })

  const reasonsTerminationsOptions = useMemo(
    () =>
      reasonsTerminationsKeys.map((reason) => {
        const translation = t(reason)
        return {
          id: translation,
          label: translation,
        }
      }),
    [t],
  )

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <AutocompleteInput
        label='form.reasons'
        placeholder='form.select reason for contract termination'
        name='reasons'
        options={reasonsTerminationsOptions}
        multiple
        autocompleteXs={12}
      />
      <br />
      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          onClick={onCancel}
          disabled={isSubmitting}
          fullWidth
        >
          {t('button.cancel')}
        </Button>
        <Button
          variant='red'
          type='submit'
          loading={isSubmitting}
          fullWidth
          startDecorator={<SlashCircleIcon color={myPalette.white.main} />}
        >
          {buttonSuccessTitle || t('button.terminate')}
        </Button>
      </Stack>
    </FormProvider>
  )
}
